import dayjs, { Dayjs } from 'dayjs';

export const dateTimeFormat = (date: Dayjs, formart = 'YYYY-MM-DD HH:mm:ss'): string =>
  dayjs(date).format(formart);

export const isRestaurantOpen = (businessHours: any[], checkTime = new Date()): boolean => {
  if (!businessHours || businessHours.length === 0) {
    return true;
  }

  // 提取检查时间的小时和分钟
  const hours = checkTime.getHours();
  const minutes = checkTime.getMinutes();
  const totalMinutes = hours * 60 + minutes;

  // 检查每个营业时间段
  for (const period of businessHours) {
    // 解析开始时间
    const [startHours, startMinutes] = period.beginTime.split(':').map(Number);
    const startTotal = startHours * 60 + startMinutes;

    // 解析结束时间
    const [endHours, endMinutes] = period.endTime.split(':').map(Number);
    const endTotal = endHours * 60 + endMinutes;

    // 检查当前时间是否在这个时间段内
    if (totalMinutes >= startTotal && totalMinutes <= endTotal) {
      return true;
    }
  }

  return false;
};

export const generateGuestGuid = (): string => {
  // 生成全球唯一ID (简化版，实际项目可使用更可靠的UUID生成方式)
  const guestGuid = 'guest-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
  // 设置过期时间为一天 (86400000毫秒)
  const expiry = Date.now() + 86400000;
  // 存储到本地缓存
  localStorage.setItem('temp-customer', JSON.stringify({ value: guestGuid, expiry }));
  return guestGuid;
};
